import { render, staticRenderFns } from "./Services_Call_Actions.vue?vue&type=template&id=5e015122&scoped=true&"
import script from "./Services_Call_Actions.vue?vue&type=script&lang=js&"
export * from "./Services_Call_Actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e015122",
  null
  
)

export default component.exports